'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { Container, Text, useTranslation } from '@weareconceptstudio/core';
import Custom404TemplateStyle from './style';
import { config } from '@/helpers';
import Button from '@/components/Button';

const Custom404Template = () => {
	const { selectedLang } = useTranslation();

	const router = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (!(pathname.replace(selectedLang + '/', '') == '/not-found/')) {
			router.push(`/${selectedLang}/not-found/`) || router.push(`/not-found/`);
		}
	}, [router, pathname, selectedLang]);

	return (
		<Custom404TemplateStyle>
			<Container
				row
				className={'error-container'}
			>
				<div className='empty-col col-3 col-dx-2 col-m-12' />

				<div className='empty-col error-inner-container col-6 col-dx-8 col-m-12'>
					<div className='inner-container'>
						<Text
							tag='h1'
							className='error-title red-1000 montserrat-400 align-center'
							text={'errorTitle'}
						/>

						<Text
							className='error-subtitle h4 black-1000 montserrat-400 align-center'
							text={'errorSubtitle'}
						/>

						<Text
							className='error-description p p2 black-1000 montserrat-400 align-center'
							text={'errorDescription'}
						/>

						<Button
							text={config.routes.home.name}
							className={'error-btn'}
							url={config.routes.home.path}
						/>
					</div>
				</div>

				<div className='empty-col col-3 col-dx-2 col-m-12' />
			</Container>
		</Custom404TemplateStyle>
	);
};

export default Custom404Template;
